import { ParamsSchema } from "@/app/used-cars/_components/search/search-results/search-params";

import { normalizeSort } from "./normalize-sort";

export function parseSearchParamsForSearch(rawParams: Record<string, any>) {
  return ParamsSchema.parse({
    ...rawParams,
    sort: normalizeSort(rawParams.sort),
  });
}
